import NextImage from '@/components/ui/next-image';
import { modifyCss } from '@/constants/Pdp';
import { validatePrice } from '@/utils/category';

const ProductLabel = ({
  labels,
  imageType = 'default', // 'default' or 'album'
  containerHeight = '220', // fallback to 220px like the first example
  labelPositions,
  price,
}) => {
  if (!labels?.length) return null;
  const prices = validatePrice(price);
  return (
    <>
      {labels.map((label, idx) => {
        if (!label || label?.status !== '1') return null;
        const imgSrc = `${process.env.NEXT_PUBLIC_IMG_BASEURL}media/amasty/amlabel/${label?.frontend_settings?.image}`;
        const hrefProps = label?.frontend_settings?.redirect_url
          ? { href: label?.frontend_settings?.redirect_url }
          : {};

        return (
          <a
            key={`label-${idx}`}
            className='absolute'
            style={{
              width: `${
                label?.frontend_settings?.image_size
                  ? `${label?.frontend_settings?.image_size}%`
                  : 'auto'
              }`,
              ...modifyCss(label?.frontend_settings?.style),
              ...labelPositions(
                prices?.specialPrice,
                label?.frontend_settings?.position
              ),
            }}
            {...hrefProps}
          >
            {imageType === 'album' ? (
              <NextImage
                src={imgSrc}
                width={labels?.at(0)?.frontend_settings?.image_size || 70}
                height={labels?.at(0)?.frontend_settings?.image_size || 70}
                alt='label'
                sizes='(max-width: 768px) 50vw, 100vw'
              />
            ) : (
              <NextImage
                src={imgSrc}
                className={`max-w-[${(label?.frontend_settings?.image_size / 100) * containerHeight}px]!`}
                width={70}
                height={70}
                alt='label'
              />
            )}
          </a>
        );
      })}
    </>
  );
};

export default ProductLabel;
